import {
    ValidationFailure,
    ValidationResult,
    FailureSeverity,
    createFailure,
    createValidationResult
} from "../validation/ValidationResult";

export interface ValidationResultBuilder {
    withWarning(message: string, code?: string): ValidationResultBuilder;
    withFailure(failure: ValidationFailure): ValidationResultBuilder;
    withError(message: string, code?: string): ValidationResultBuilder;
    build(): ValidationResult;
}

export const validationResultBuilder = (): ValidationResultBuilder => {
    const failures: ValidationFailure[] = [];

    const withWarning = (message: string, code?: string) => {
        failures.push(createFailure(message, code ?? "", FailureSeverity.Warning));
        return builder;
    };

    const withError = (message: string, code?: string) => {
        failures.push(createFailure(message, code ?? "", FailureSeverity.Error));
        return builder;
    };

    const withFailure = (failure: ValidationFailure) => {
        failures.push(failure);
        return builder;
    };

    const build = () => {
        return createValidationResult(failures);
    };

    const builder: ValidationResultBuilder = {
        withWarning,
        withError,
        withFailure,
        build
    };

    return builder;
};

export const createErrorFailure = (message: string, code = ""): ValidationFailure => {
    return {
        message,
        code,
        severity: FailureSeverity.Error
    };
};

export const createWarningFailure = (message: string, code = ""): ValidationFailure => {
    return {
        message,
        code,
        severity: FailureSeverity.Warning
    };
};
